import { Controller } from "@hotwired/stimulus";
import { openDocumentPanel, openImagePanel } from "./panel/index.js";

export default class extends Controller {
  static values = {
    title: String,
    documentUrl: String,
    imageUrl: String,
    mediaUrl: String,
  };

  open() {
    const options = {
      title: this.titleValue,
    };
    // Media files (audio/video): open in a new browser tab for native playback.
    // The URL is decoded here because documentUrl from the backend contains
    // HTML-encoded ampersands (&amp;) which must be decoded to & before use
    // as a navigation URL - matching the decodeUrl() behaviour in
    // document_menu_controller.js for the context menu path.
    if (this.hasMediaUrlValue) {
      const url = this.mediaUrlValue.replaceAll("&amp;", "&");
      window.open(url, '_blank');
    } else if (this.hasDocumentUrlValue) {
      openDocumentPanel({ ...options, url: this.documentUrlValue });
    } else if (this.hasImageUrlValue) {
      openImagePanel({ ...options, url: this.imageUrlValue });
    } else {
      console.error("no url provided");
    }
  }
}
